import { useTranslation } from "react-i18next";

const Spinner = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-30 flex items-center justify-center bg-gray-300/50">
      <div className="bg-white rounded-2xl shadow-lg p-4 flex flex-col items-center gap-3 min-w-[280px] max-w-[320px]">
        <div className="relative">
          <svg
            className="animate-spin w-8 h-8"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 34 34"
            fill="none"
          >
            <path
              d="M31.6663 17L31.6105 15.7217L31.4435 14.4532L31.1666 13.204L30.7818 11.9837L30.2922 10.8016L29.7014 9.66668L29.0139 8.58756L28.235 7.57246L27.3706 6.62911L26.4272 5.76469L25.4121 4.98578L24.333 4.2983L23.1981 3.7075L22.016 3.21785L20.7957 2.8331L19.5465 2.55616L18.278 2.38916L17 2.33334L15.7214 2.38916L14.4528 2.55616L13.2037 2.8331L11.9834 3.21785L10.8013 3.7075L9.66634 4.2983L8.58722 4.98578L7.57212 5.76469L6.62878 6.62911L5.76436 7.57246L4.98544 8.58756L4.29797 9.66668L3.70716 10.8016L3.21752 11.9837L2.83276 13.204L2.55583 14.4532L2.38882 15.7217L2.33301 17L2.38882 18.2783L2.55583 19.5468L2.83276 20.796L3.21752 22.0163L3.70716 23.1984"
              stroke="#0E0D0D"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <div className="text-center w-full flex flex-col gap-3">
          <p className="text-text font-medium leading-[20.8px] text-base tracking-[-0.4px]">
            {t("common:spinner.wait")}
          </p>
          <p className="text-text leading-[18.2px] text-sm">
            {t("common:spinner.processing")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
